import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { LayoutSliceState } from "./types/redux";

/**
 * Layout slice manages the overall UI layout mode for the application.
 * It tracks whether the app is in 'chat' mode (centered, full-width chat)
 * or 'workspace' mode (split view with results/documents visible).
 */
const initialState: LayoutSliceState = {
  layoutMode: 'chat', // 'chat' | 'workspace'
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    /**
     * Set the layout mode
     * @param {object} state - Current state
     * @param {object} action - Action with payload: 'chat' | 'workspace'
     */
    setLayoutMode: (state, action: PayloadAction<'chat' | 'workspace'>) => {
      const newMode = action.payload;
      if (newMode === 'chat' || newMode === 'workspace') {
        state.layoutMode = newMode;
      } else {
      }
    },

    /**
     * Reset layout to initial state (chat mode)
     */
    resetLayout: (state) => {
      state.layoutMode = 'chat';
    },
  },
});

export const {
  setLayoutMode,
  resetLayout,
} = layoutSlice.actions;

// Selectors
export const selectLayoutMode = (state) => state.layoutSlice?.layoutMode || 'chat';

export default layoutSlice.reducer;
